// extracted by mini-css-extract-plugin
export var fadeIn = "_cr-1";
export var modalContent = "_cr-3";
export var overlay = "_cr-0";
export var popoverContent = "_cr-2";
export var results = "_cr-5";
export var searchInputWrapper = "_cr-4";